// Sezione Download in-app (sotto il navbar), unica per browser, vecchie app
// Cordova e app Capacitor. Su Android la riproduzione usa il player nativo
// (@capgo/capacitor-video-player, AVPlayer/ExoPlayer sotto): per l'HLS
// locale funziona bene. Su iOS AVPlayer/AVAsset NON riproduce in modo
// affidabile un HLS multi-file (master.m3u8 + segmenti) letto via file://
// (limite noto di AVFoundation, indipendente dalla connessione): il video
// scaricato riproduce quindi con lo stesso player in-webview (TyPlayer) già
// usato per lo streaming online, puntato sul file locale via /_capacitor_file_/.

function isCapacitorNative() {
    try {
        return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    } catch (err) {
        return false;
    }
}

function ensureDownloadedIOSOverlayStyle() {
    if (document.getElementById('downloaded-ios-overlay-style')) return;
    var style = document.createElement('style');
    style.id = 'downloaded-ios-overlay-style';
    style.textContent = '.downloaded-ios-overlay{position:fixed;inset:0;z-index:2147483647;background:#000;display:flex;align-items:center;justify-content:center}' +
        '.downloaded-ios-overlay video{width:100%;height:100%;background:#000;object-fit:contain}' +
        '.downloaded-ios-close{position:absolute;top:max(20px,env(safe-area-inset-top));right:max(14px,env(safe-area-inset-right));width:40px;height:40px;border:none;border-radius:999px;background:rgba(0,0,0,.55);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer}';
    document.head.appendChild(style);
}

function closeDownloadedIOSOverlay() {
    try {
        if (!downloadedIOSOverlayEl) return;
        var video = downloadedIOSOverlayEl.querySelector('video');
        if (video) video.pause();
        downloadedIOSOverlayEl.remove();
    } catch (err) {}
    downloadedIOSOverlayEl = null;
}

function openDownloadedIOSOverlay(source, title, poster) {
    ensureDownloadedIOSOverlayStyle();
    closeDownloadedIOSOverlay();

    var overlay = document.createElement('div');
    overlay.className = 'downloaded-ios-overlay';

    var video = document.createElement('video');
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.title = title || '';
    if (poster) video.poster = poster;
    video.src = source;

    var closeBtn = document.createElement('button');
    closeBtn.className = 'downloaded-ios-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    closeBtn.addEventListener('click', closeDownloadedIOSOverlay);
    overlay.addEventListener('click', function(ev) {
        if (ev.target === overlay) closeDownloadedIOSOverlay();
    });

    overlay.appendChild(video);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);
    downloadedIOSOverlayEl = overlay;

    return video;
}

function buildLocalPlaybackSources(nativePath) {
    var sources = [];
    function pushOnce(url) {
        if (!url) return;
        if (sources.indexOf(url) === -1) sources.push(url);
    }

    var normalized = (nativePath || '').replace('file://', '');
    var fileUrl = normalized && normalized.charAt(0) === '/' ? ('file://' + normalized) : nativePath;

    pushOnce(localPathToWebViewSrc(nativePath));

    try {
        if (window.Capacitor && typeof window.Capacitor.convertFileSrc === 'function') {
            pushOnce(window.Capacitor.convertFileSrc(nativePath));
            pushOnce(window.Capacitor.convertFileSrc(fileUrl));
            pushOnce(window.Capacitor.convertFileSrc(normalized));
        }
    } catch (err) {}

    pushOnce(fileUrl);
    pushOnce(nativePath);
    return sources;
}

function playVideoWithSourceFallback(video, sources) {
    if (!video || !sources || !sources.length) return;
    var index = 0;

    function playIndex(i) {
        if (i >= sources.length) {
            try { window.plugins.toast.showShortBottom(translate('SOMETHING_WENT_WRONG')); } catch (e) {}
            return;
        }
        index = i;
        video.src = sources[i];
        var p = video.play();
        if (p && p.catch) p.catch(function() {});
    }

    video.addEventListener('error', function() {
        playIndex(index + 1);
    });

    playIndex(0);
}

function playDownloadedIOSOverlay(id, title, img) {
    var masterPath = cordova.file.dataDirectory + 'video/' + id + '/master.m3u8';
    var previewPath = cordova.file.dataDirectory + 'video/' + id + '/preview.jpg';
    window.resolveLocalFileSystemURL(masterPath, function(fileEntry) {
        var nativeSource = fileEntry.nativeURL ? fileEntry.nativeURL : fileEntry.toURL();
        var sources = buildLocalPlaybackSources(nativeSource);
        var remotePoster = (img && (img.indexOf('http://') === 0 || img.indexOf('https://') === 0)) ? img : '';

        window.resolveLocalFileSystemURL(previewPath, function(previewEntry) {
            var nativePoster = previewEntry.nativeURL ? previewEntry.nativeURL : previewEntry.toURL();
            var video = openDownloadedIOSOverlay(sources[0] || '', title, localPathToWebViewSrc(nativePoster) || remotePoster);
            playVideoWithSourceFallback(video, sources);
        }, function() {
            var video = openDownloadedIOSOverlay(sources[0] || '', title, remotePoster);
            playVideoWithSourceFallback(video, sources);
        });
    }, function(error) {
        console.error("Errore nell'accesso al file:", error);
        try { window.plugins.toast.showShortBottom(translate('SOMETHING_WENT_WRONG')); } catch (e) {}
    });
}

function isCapacitorIOS() {
    try {
        return isCapacitorNative() && window.Capacitor.getPlatform() === 'ios';
    } catch (err) {
        return false;
    }
}

// Converte un path locale (file:// o assoluto) nell'URL /_capacitor_file_/
// servito dalla WebView.
// - Android: il path viene intercettato indipendentemente dall'origin
//   corrente, quindi si costruisce su location.origin (funziona identico
//   online, nella SPA da server remoto, e offline nella pagina errorPath).
// - iOS: lo scheme handler di Capacitor è registrato SOLO sullo scheme/host
//   locale del bridge (capacitor://localhost di default, esposto in JS come
//   window.WEBVIEW_SERVER_URL), a prescindere da quale pagina sia
//   effettivamente caricata. Nella pagina offline (errorPath, servita da
//   quello stesso origin locale) location.origin combacia per coincidenza,
//   ma nella SPA online (servita dall'origin remoto di server.url) NON
//   combacia: costruire l'URL su location.origin manda la richiesta sulla
//   rete reale verso il server remoto (che non la capisce) invece di farla
//   intercettare dal bridge nativo -> il player resta bloccato in loading.
//   Va quindi sempre usato il local bridge origin, non location.origin.
function localPathToWebViewSrc(path) {
    if (!path) return '';
    var normalized = path.replace('file://', '');
    if (normalized.charAt(0) !== '/') return path;

    var base = location.origin;
    if (isCapacitorIOS()) {
        base = (typeof window.WEBVIEW_SERVER_URL === 'string' && window.WEBVIEW_SERVER_URL) || 'capacitor://localhost';
    }
    return base + '/_capacitor_file_' + encodeURI(normalized);
}

// La thumb in db è l'URL remoto (non viene più sovrascritto col path locale).
// I record vecchi possono contenere ancora un path locale: su Capacitor è
// servibile via /_capacitor_file_/ su entrambe le piattaforme; altrimenti
// placeholder.
function resolveDownloadThumbSrc(img) {
    if (!img) return '/img/gray1px.jpg';
    if (img.indexOf('http://') === 0 || img.indexOf('https://') === 0) return img;

    var path = img.replace('file://', '');
    if (isCapacitorNative() && path.charAt(0) === '/') {
        return localPathToWebViewSrc(path);
    }
    return img;
}

// Funzione per visualizzare i video scaricati
function listDownloaded() {
    // Controlla la connessione (modalità offline delle vecchie app locali)
    if (ONLINE_STATUS === false) {
        $('.download-offline-mode').show();
        $('.pageMob').hide();
	    $('.pageMob-download').show();
        $('.header-mobile-native').hide();
        $('.navbar-mobile-native').hide();
    }else{
        $('.download-offline-mode').hide();
    }

    const listDownloaded = $('.list-downloaded');
    listDownloaded.empty();

    db.transaction(function(tx) {
        tx.executeSql('SELECT * FROM download ORDER BY progress DESC, download_date DESC', [], function(tx, result) {
            if(result.rows.length == 0){
                try{
                    listDownloaded.append(`<div class='white text-center' style=" margin-top:30vh;"><i class="ri-download-fill white" style="font-size:56px; opacity:0.5;"></i><p>${translate('NO_CONTENTS_DOWNLOADED')}</p></div>`);
                }catch(err){
                    listDownloaded.append(`<div class='white text-center' style=" margin-top:30vh;"><i class="ri-download-fill white" style="font-size:56px; opacity:0.5;"></i><p>No contents downloaded</p></div>`);
                }
                return false;
            }

            for (var i = 0; i < result.rows.length; i++) {
                var item = result.rows.item(i);

                var days_until_expiration = null;
                if(item.deadline > 0){
                    var expiration_date = new Date(item.download_date);
                    expiration_date.setDate(expiration_date.getDate() + item.deadline);
                    var current_date = new Date();
                    days_until_expiration = Math.ceil((expiration_date - current_date) / (1000 * 60 * 60 * 24));
                }

                // IIFE: handler con closure sull'item, niente onclick inline
                (function(item, days_until_expiration) {
                    const listItem = $(`
                        <li class="list-item" id="offline-video-id-${item.id}">
                            <div class="list-item__image">
                                <img src="${resolveDownloadThumbSrc(item.img)}" alt="Thumbnail">
                            </div>
                            <div class="list-item__content">
                                ${ item.title != item.collection_title && item.collection_title ? `<span style="font-size:14px;" class="gray xbold">${$('<i>').text(item.collection_title).html()}</span>`:``}
                                <p class="white" style="margin:0;">${$('<i>').text(item.title || '').html()}</p>
                                ${(item.progress < 100) ? `
                                <div class="progress-bar-wrapper" id="progressBarWrapper-${item.id}">
                                    <div class="progress-bar">
                                        <div id="progress-bar-wrapper-fill-${item.id}" class="progress-bar__fill" style="width: ${item.progress}%"></div>
                                    </div>
                                    <span id="progress-bar-wrapper-value-${item.id}" class="progress-bar-wrapper-value"></span>
                                </div>
                                ` : (days_until_expiration != null ? `<span class="gray" style="font-size:12px;"><i class="ri-time-line"></i> ${days_until_expiration}d</span>` : ``)}
                            </div>
                            <button class="download-item-trash" aria-label="Delete"><i class="ri-delete-bin-line" style="font-size:18px;"></i></button>
                        </li>
                    `);

                    listItem.find('img').on('error', function() {
                        $(this).off('error').attr('src', '/img/gray1px.jpg');
                    });

                    // tap sull'elemento: riproduci (solo se il download è completo)
                    listItem.on('click', function() {
                        playDownloadedItem(item.id, item.title, item.img);
                    });

                    // cestino: chiede conferma con la modal dell'app
                    listItem.find('.download-item-trash').on('click', function(ev) {
                        ev.stopPropagation();
                        confirmRemoveDownload(item.id);
                    });

                    listDownloaded.append(listItem);
                })(item, days_until_expiration);
            }

        }, function(error) {
            console.error("Errore durante il recupero dei dati dal database:", error);
        });
    });

}

// Modal di conferma prima di eliminare un download
function confirmRemoveDownload(id){
    try{ addPageToState('modal-generic'); }catch(err){}

    var deleteText = 'Delete', cancelText = 'Cancel';
    try{ var d = translate('DELETE'); if(d && d !== 'DELETE') deleteText = d; }catch(err){}
    try{ var c = translate('CANCEL'); if(c && c !== 'CANCEL') cancelText = c; }catch(err){}

    $('#modal-body-generic').html(`
        <div class="mod-custom-option" id="download-remove-confirm" style="color:#ff5b5b;"><i class="ri-delete-bin-line"></i> ${deleteText}</div>
        <div class="mod-custom-option" id="download-remove-cancel"><i class="ri-close-line"></i> ${cancelText}</div>
    `);
    $('#download-remove-confirm').on('click', function(){
        closeRemoveDownloadModal();
        removeVideoOffline(id);
    });
    $('#download-remove-cancel').on('click', closeRemoveDownloadModal);

    BSLight.ModalShow('#modal-generic');
}

function closeRemoveDownloadModal(){
    try{
        Nav.dismissTop('modal-generic');
    }catch(err){
        try{ BSLight.ModalHide('#modal-generic'); }catch(e){}
    }
}

async function removeVideoOffline(id){
    closeDownloadedIOSOverlay();
    $('#offline-video-id-'+id).remove();
    cancelDownloadNavBadge(id); // rimuove l'elemento dal badge navbar
    await deleteVideoDownloaded(id);
    // se non resta nulla, rimostra lo stato vuoto
    if ($('.list-downloaded .list-item').length === 0) {
        listDownloaded();
    }
}

// ---- badge sulla voce Download della navbar ----
// Punto rosso fisso, visibile finché c'è almeno un download in corso.
// Alimentato da updateProgressBars.
var activeDownloadProgress = {};
// Download annullati: i chunk già partiti continuano a scrivere il progresso
// per qualche istante dopo la cancellazione, e riaccenderebbero il punto rosso
// senza che nessuno lo spenga più. Gli update su questi id vengono ignorati.
var cancelledDownloadIds = {};
var downloadedIOSOverlayEl = null;

function updateDownloadNavBadge(id, progress) {
    if (cancelledDownloadIds[id]) return;
    if (progress >= 100) {
        delete activeDownloadProgress[id];
    } else {
        activeDownloadProgress[id] = Math.max(0, Number(progress) || 0);
    }
    renderDownloadNavBadge();
}

// Chiamata quando l'utente cancella un download (anche se in corso).
function cancelDownloadNavBadge(id) {
    cancelledDownloadIds[id] = true;
    delete activeDownloadProgress[id];
    renderDownloadNavBadge();
}

// Un nuovo download sullo stesso id torna a essere valido.
function resetCancelledDownloadNavBadge(id) {
    delete cancelledDownloadIds[id];
}

// Riconciliazione col db: toglie dal badge gli id che non hanno più un
// download in corso (cancellati, scaduti, falliti dopo troppi tentativi).
function syncDownloadNavBadgeFromDb() {
    var tracked = Object.keys(activeDownloadProgress);
    if (!tracked.length) return;
    try{
        db.transaction(function(tx) {
            tx.executeSql('SELECT id FROM download WHERE progress < 100', [], function(tx, result) {
                var alive = {};
                for (var i = 0; i < result.rows.length; i++) {
                    alive[String(result.rows.item(i).id)] = true;
                }
                for (var j = 0; j < tracked.length; j++) {
                    if (!alive[tracked[j]]) delete activeDownloadProgress[tracked[j]];
                }
                renderDownloadNavBadge();
            });
        });
    }catch(err){}
}

function renderDownloadNavBadge() {
    var $item = $('.navbar-mobile-native .menu-item[rel="download"]');
    if (!$item.length) return;

    var $badge = $item.find('.download-nav-badge');
    if (!Object.keys(activeDownloadProgress).length) {
        $badge.remove();
        return;
    }
    if (!$badge.length) {
        var $icon = $item.find('.menu-item__icon');
        ($icon.length ? $icon : $item).append('<span class="download-nav-badge"></span>');
    }
}

// Tap su un elemento della lista: verifica che il download sia completo e
// lo riproduce SEMPRE da sorgente locale se aperto dalla sezione Download.
// In questa sezione il video non deve mai passare da HTTPS, anche quando
// la rete e' disponibile.
function playDownloadedItem(id, title, img) {
    db.transaction(function(tx) {
        tx.executeSql('SELECT id FROM download WHERE progress=100 AND id=?', [id], function(tx, result) {
            if (result.rows.length === 0) {
                try{ window.plugins.toast.showShortBottom(translate('VIDEO_PLAY_DONWLOAD_IN_PROGRESS')); }catch(err){}
                return;
            }
            // Android: plugin nativo (AVPlayer/ExoPlayer) — l'HLS locale
            // funziona bene con file://.
            // iOS: AVPlayer/AVAsset NON riproduce in modo affidabile un HLS
            // multi-file locale (limite noto di AVFoundation) e il wrapper
            // TyPlayer nella SPA online ha dato errori intermittenti:
            // in Download si usa un <video> diretto in overlay, alimentato
            // da sorgente locale /_capacitor_file_.
            if (isCapacitorIOS()) {
                playDownloadedIOSOverlay(id, title, img);
            } else if (isCapacitorNative()) {
                playDownloadedNativePlayer(id, title, img);
            } else {
                loadVideoOffline(id, title, img);
            }
        });
    });
}

// Player NATIVO (solo Android): il layer nativo legge direttamente il file,
// funziona da qualsiasi origin e anche offline.
function playDownloadedNativePlayer(id, title, img) {
    var masterPath = cordova.file.dataDirectory + 'video/' + id + '/master.m3u8';
    window.resolveLocalFileSystemURL(masterPath, function(fileEntry) {
        var source = fileEntry.nativeURL ? fileEntry.nativeURL : fileEntry.toURL();
        var plugins = window.Capacitor && window.Capacitor.Plugins;
        var player = plugins && (plugins.CapacitorVideoPlayer || plugins.VideoPlayer);
        if (!player) {
            console.error('Plugin video player nativo non disponibile');
            return;
        }

        // artwork: preview locale se c'è, altrimenti l'URL remoto della thumb
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory + 'video/' + id + '/preview.jpg', function(previewEntry) {
            startNativePlayer(player, source, title, previewEntry.nativeURL || '');
        }, function() {
            startNativePlayer(player, source, title, (img && img.indexOf('http') === 0) ? img : '');
        });
    }, function(error) {
        console.error("Errore nell'accesso al file:", error);
    });
}

function startNativePlayer(player, source, title, artwork) {
    player.initPlayer({
        playerId: 'downloaded-player',
        mode: 'fullscreen',
        url: source,
        title: title || '',
        artwork: artwork || '',
        chromecast: false,
        pipEnabled: false,
        showControls: true,
        exitOnEnd: true
    }).catch(function(error) {
        console.error(error);
    });
}

// Player WEB in-app (TyPlayer, lo stesso dello streaming online): usato per
// iOS Capacitor (vedi nota sopra su AVPlayer + HLS locale) e per il vecchio
// fallback browser/Cordova. La sorgente locale viene servita tramite
// /_capacitor_file_/ sull'origin corrente, cosi' hls.js / il tag <video>
// nativo la raggiungono dal contesto WebView (a differenza di AVAsset creato
// da codice nativo, che quello schema non lo risolve).
function loadVideoOffline(id, title=null, img=null) {

    if(!img){
        img = "/img/void1px.jpg";
    }
     db.transaction(function(tx) {
        tx.executeSql('SELECT id FROM download WHERE progress=100 AND id=?', [id], async function(tx, result) {
            if(result.rows.length > 0){
                var videoUrl = cordova.file.dataDirectory + 'video/' + id + '/master.m3u8';
                window.resolveLocalFileSystemURL(videoUrl, function(fileEntry) {
                    var nativeUrl = fileEntry.nativeURL ? fileEntry.nativeURL : fileEntry.toURL();
                    var data = {
                        source: localPathToWebViewSrc(nativeUrl),
                        source_type: 'application/x-mpegURL',
                        title: title,
                        img_preview: img
                    }
                    loadPageVideo(null, data);
                }, function(error) {
                    console.error("Errore nell'accesso al file:", error);
                });
            }else{
                window.plugins.toast.showShortBottom(translate('VIDEO_PLAY_DONWLOAD_IN_PROGRESS'));
            }
        })
     });
}
